import React, { Component, useEffect, useState } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { flattenErrors } from './ErrorHelpers';
import moment from 'moment';
import { createEvent } from 'ics';
import { PhotoshootType } from './enums'

export function BookPhotoshootComponent({ accountNumber, bottomMessage, refundText, noDatesAvailableMessage, initialSelectedDate, hasHadOrScheduledHeadType, canBookSpecial }) {
    const [selectedDate, setSelectedDate] = useState(moment().startOf('week'));
    const [loading, setLoading] = useState(true);
    const [timeSlots, setTimeSlots] = useState(null);
    
    // Check for success/canceled query parameters
    const urlParams = new URLSearchParams(window.location.search);
    const paymentSuccess = urlParams.get('success') === 'true';
    const paymentCanceled = urlParams.get('canceled') === 'true';
    const [selectedTimeSlot, selectTimeSlot] = useState(null);
    const [currentScreen, setScreen] = useState(1);
    const [errors, setErrors] = useState(null);
    const [times, setTimes] = useState(null);
    const [address, setAddress] = useState({});
    const [tax, setTax] = useState(0);
    const [rsvpId, setRsvpId] = useState(null);
    // Default to Body so the submitted type matches the selector's displayed value even if the
    // student never opens the dropdown. (The dropdown is only shown once a Head shot exists, and
    // Body is always a valid option there.) Without this, an untouched select submits no type.
    const [selectedPhotoshootType, setPhotoshootType] = useState({ photoshootType: PhotoshootType.Body.toString() });





    function updatePhotoshootType(e) {
        setPhotoshootType({
            ...selectedPhotoshootType,
            [e.target.name]: e.target.value
        });
    }

    
    function updateAddress(e) {
        setAddress({
            ...address,
            [e.target.name]: e.target.value
        });
    }


    useEffect(() => {
        fetch(`/api/talent/photoshoot/timeslots`,
            {
                method: "GET"
            })
            .then(req => {
                if (req.status === 422) {
                    setScreen(4);
                    throw new Error('Unprocessable Entity');
                }
                return req.json();
            })
            .then(resp => {
                const timeslots = {};
                resp = resp.sort((a, b) => moment(a.dateTime).valueOf() - moment(b.dateTime).valueOf());

                for (const i of resp) {
                    if (i.publishToJcStudentPortalHomePage) {
                        // parseZone keeps the offset the server sent (the student's selected
                        // time zone) instead of converting to the browser's local zone.
                        i.dateTime = moment.parseZone(i.dateTime);
                        const currentDate = i.dateTime.format("YYYY-MM-DD");

                        if (!timeslots[currentDate]) {
                            timeslots[currentDate] = [];
                        }
                        timeslots[currentDate].push(i);
                    }
                }
                setLoading(false);
                setTimeSlots(timeslots);
            })
            .catch(error => {
                setLoading(false);
            });
    }, []);

    useEffect(() => {
        if (initialSelectedDate && timeSlots) {
            const initialDate = moment(initialSelectedDate).format("YYYY-MM-DD");
            if (timeSlots[initialDate]) {
                selectDate(initialDate);
            }
        }
    },
        [timeSlots]);

    function book() {
        setErrors(null);
        setLoading(true);
        fetch(`/api/talent/${accountNumber}/photoshoot/book`,
            {
                method: "POST",
                body: JSON.stringify({
                    ...address,
                    TimeSlotId: selectedTimeSlot.timeSlotId,
                    EventId: selectedTimeSlot.id,
                    Source: "Booked by talent on Book Photoshoot page",
                    PhotoshootType: hasHadOrScheduledHeadType ? selectedPhotoshootType["photoshootType"] : PhotoshootType.Head
                }),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
            .then(req => {
                setLoading(false);
                if (req.ok) {
                    req.json().then(resp => {
                        if (resp.redirectUrl) {
                            // Paid photoshoot - redirect to Stripe checkout
                            window.location.href = resp.redirectUrl;
                        } else {
                            // Free photoshoot - show success screen
                            setScreen(3);
                            setRsvpId(resp.id);
                        }
                    });
                } else {
                    req.json().then(resp => setErrors(resp.errors));
                }
            });
    }

    function goNext() {
        setErrors(null);
        setLoading(true);
        fetch(`/api/talent/${accountNumber}/photoshoot/calculatesalestax`,
            {
                method: "POST",
                body: JSON.stringify({
                    ...address,
                    eventId: selectedTimeSlot.id
                }),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
            .then(req => {
                setLoading(false);
                if (req.ok) {
                    req.json().then(resp => {
                        setTax(resp.tax);
                        setScreen(2);
                    });
                } else {
                    req.json().then(resp => setErrors(resp.errors));
                }
            });
    }

    function getCurrentEventAddress() {
        const location = selectedTimeSlot.eventLocation;
        return `${location.address1}, ${location.address2 || ""}${(location.address2 && ", ") || ""}${location.city}, ${location.state}, ${location.zip}`;
    }

    function downloadIcs() {
        const e = selectedTimeSlot;
        const d = e.dateTime;
        const event = {
            start: [d.year(), d.month(), d.day(), d.hour(), d.minute()],
            duration: {
                minutes: e.durationInMinutes
            },
            title: "Photoshoot",
            description: "Photoshoot",
            url: "https://www.jcasablancas.com",
            status: "CONFIRMED",
            busyStatus: "BUSY"
        };

        if (selectedTimeSlot.eventLocation) {
            event.location = getCurrentEventAddress();
        } else {
            event.location = "Zoom";
        }

        createEvent(event,
            (error, value) => {
                window.open("data:text/calendar;charset=utf8," + escape(value));
            });
    }

    function selectDate(date) {
        const times = timeSlots[date];
        setTimes(times);
        setSelectedDate(date);
        selectTimeSlot(null);
    }

    return (
        <>
            {paymentSuccess && <div className="alert alert-success alert-dismissible fade show" role="alert">
                <strong>Payment Successful!</strong> Your photoshoot has been booked successfully.
                <button type="button" className="close" data-dismiss="alert" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>}
            
            
            {currentScreen === 1 && <div>
                <div className="row">
                    <div className="col-lg-12 col-xl-6">
                        <div id="ps-dates" className="card mb-2">
                            <div className="card-body">
                                <div className="card-title">
                                    <h5 className="text-center">Select a Date</h5>
                                    {timeSlots && !!Object.keys(timeSlots).length && Object.keys(timeSlots).map(date => <button className={"btn btn-block btn-lg " + (date === selectedDate ? "btn-primary" : "btn-outline-primary")}
                                        onClick={() => selectDate(date)}>{moment(date).format("dddd, MMMM Do YYYY")}</button>)}
                                    {timeSlots && !Object.keys(timeSlots).length && <div className="text-center">{noDatesAvailableMessage}</div>}
                                    {loading && <h2 className="text-center">Loading...</h2>}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-12 col-xl-6">
                        <div id="ps-times" className="card mb-2">
                            <div className="card-body">
                                <div className="card-title">
                                    <h5 className="text-center">Select a Time</h5>
                                    {times && times.map(t => (
                                        <button className="btn btn-lg btn-outline-primary btn-block" style={{ whiteSpace: "nowrap" }}
                                            onClick={() => selectTimeSlot(t)}>
                                            {t.dateTime.format("h:mm A")}{t.timeZoneAbbreviation ? ` ${t.timeZoneAbbreviation}` : ""}
                                        </button>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-12 col-xl-10 offset-xl-1">
                        <div className="card mb-2">
                            <div className="card-body">
                                {!selectedTimeSlot &&
                                    <div className="card-title">
                                        <h5 className="text-center">Confirm Details</h5>
                                    </div>}
                                {selectedTimeSlot && <div>
                                    <div className="card-title">
                                        <h3>Photoshoot</h3>
                                    </div>
                                    <h4>{selectedTimeSlot.dateTime.format("LLL")}{selectedTimeSlot.timeZoneAbbreviation ? ` ${selectedTimeSlot.timeZoneAbbreviation}` : ""}</h4>

                                    {(selectedTimeSlot.cost > 0 || selectedTimeSlot.preDiscountCost > 0) &&
                                        <h5>Fee: {selectedTimeSlot.preDiscountCost ? <span style={{ color: "grey", textDecoration: "line-through" }}>${selectedTimeSlot.preDiscountCost.toFixed(2)}</span> : ""} ${selectedTimeSlot.cost}</h5>}
                                    <hr />

                                    {selectedTimeSlot.eventLocation && <>
                                        <h4>Location</h4>
                                        <address>
                                            <strong>
                                                {selectedTimeSlot.eventLocation.name}
                                            </strong><br />

                                            {selectedTimeSlot.eventLocation.address1}<br />
                                            {selectedTimeSlot.eventLocation.address2}{selectedTimeSlot.eventLocation.address2 && <br />}
                                            {selectedTimeSlot.eventLocation.city}, {selectedTimeSlot.eventLocation.state} {selectedTimeSlot.eventLocation.zip}
                                        </address>
                                    </>}

                                    {!selectedTimeSlot.eventLocation && <p>Hosted on Zoom</p>}

                                    <hr />

                                    <h4>Type</h4>
                                    <div className="form-group">
                                        {hasHadOrScheduledHeadType &&
                                            <select name="photoshootType" className="form-control col-2" value={selectedPhotoshootType.photoshootType} onChange={updatePhotoshootType}>
                                                {Object.keys(PhotoshootType).reverse()
                                                    .filter((type) => type !== 'Special' || canBookSpecial)
                                                    .map((type) => (
                                                    <option key={PhotoshootType[type]} value={PhotoshootType[type]}>{type}</option>
                                                ))}
                                            </select>
                                        }
                                        {!hasHadOrScheduledHeadType &&
                                            <text>Head</text>
                                        }
                                        {!hasHadOrScheduledHeadType &&
                                            <select style={{display: "none"}}  name="photoshootType" className="form-control col-2" onChange={updatePhotoshootType}>
                                                <option value={PhotoshootType['Head']}>Head</option>
                                            </select>
                                        }
                                        
                                      

                                    </div>
                                    <hr />
                                    <h4>Enter your address</h4>
                                    <div className="form-group">
                                        <input name="address1" className="form-control mr-2" placeholder="Address 1" onChange={updateAddress} />
                                    </div>
                                    <div className="form-group">
                                        <input name="address2" className="form-control mr-2" placeholder="Address 2" onChange={updateAddress} />
                                    </div>
                                    <div className="form-inline mb-2">
                                        <input name="city" className="form-control col-lg-12 col-xl-6 mb-3" placeholder="City" onChange={updateAddress} />
                                        <select name="state" className="form-control col-lg-12 col-xl-3 mb-3" placeholder="State" onChange={updateAddress}>
                                            <option value="" disabled selected>State</option>
                                            <option value="AL">AL</option>
                                            <option value="AK">AK</option>
                                            <option value="AR">AR</option>
                                            <option value="AZ">AZ</option>
                                            <option value="CA">CA</option>
                                            <option value="CO">CO</option>
                                            <option value="CT">CT</option>
                                            <option value="DC">DC</option>
                                            <option value="DE">DE</option>
                                            <option value="FL">FL</option>
                                            <option value="GA">GA</option>
                                            <option value="HI">HI</option>
                                            <option value="IA">IA</option>
                                            <option value="ID">ID</option>
                                            <option value="IL">IL</option>
                                            <option value="IN">IN</option>
                                            <option value="KS">KS</option>
                                            <option value="KY">KY</option>
                                            <option value="LA">LA</option>
                                            <option value="MA">MA</option>
                                            <option value="MD">MD</option>
                                            <option value="ME">ME</option>
                                            <option value="MI">MI</option>
                                            <option value="MN">MN</option>
                                            <option value="MO">MO</option>
                                            <option value="MS">MS</option>
                                            <option value="MT">MT</option>
                                            <option value="NC">NC</option>
                                            <option value="NE">NE</option>
                                            <option value="NH">NH</option>
                                            <option value="NJ">NJ</option>
                                            <option value="NM">NM</option>
                                            <option value="NV">NV</option>
                                            <option value="NY">NY</option>
                                            <option value="ND">ND</option>
                                            <option value="OH">OH</option>
                                            <option value="OK">OK</option>
                                            <option value="OR">OR</option>
                                            <option value="PA">PA</option>
                                            <option value="RI">RI</option>
                                            <option value="SC">SC</option>
                                            <option value="SD">SD</option>
                                            <option value="TN">TN</option>
                                            <option value="TX">TX</option>
                                            <option value="UT">UT</option>
                                            <option value="VT">VT</option>
                                            <option value="VA">VA</option>
                                            <option value="WA">WA</option>
                                            <option value="WI">WI</option>
                                            <option value="WV">WV</option>
                                            <option value="WY">WY</option>
                                        </select>
                                        <input name="zip" className="form-control col-lg-12 col-xl-3 mb-3" placeholder="ZIP" onChange={updateAddress} maxlength="5" />
                                    </div>
                                    <a href="javascript:void(220221)" className="btn btn-primary btn-block" onClick={goNext}>
                                        Next
                                    </a>

                                    {errors && <ul>
                                        {Object.keys(errors).flatMap(key => errors[key].map(error => <li>{error}</li>))}
                                    </ul>}
                                </div>}
                            </div>
                        </div>
                    </div>
                </div>
            </div>}
            {currentScreen === 2 && <div className="col-lg-12 col-xl-10 offset-xl-1">
                <div className="card">
                    <div className="card-body">
                        {errors && <ul>
                            {Object.keys(errors).flatMap(key => errors[key].map(error => <li>{error}</li>))}
                        </ul>}

                        <h4>{selectedTimeSlot.dateTime.format("LLL")}{selectedTimeSlot.timeZoneAbbreviation ? ` ${selectedTimeSlot.timeZoneAbbreviation}` : ""}</h4>

                        {selectedTimeSlot.eventLocation && <address>
                            <strong>
                                {selectedTimeSlot.eventLocation.name}
                            </strong><br />

                            {selectedTimeSlot.eventLocation.address1}<br />
                            {selectedTimeSlot.eventLocation.address2}{selectedTimeSlot.eventLocation.address2 && <br />}
                            {selectedTimeSlot.eventLocation.city}, {selectedTimeSlot.eventLocation.state} {selectedTimeSlot.eventLocation.zip}
                        </address>}

                        {!selectedTimeSlot.eventLocation && <div>Hosted on Zoom</div>}

                        {selectedTimeSlot.cost > 0 && <div>
                            <div className="row mb-2">
                                <div className="col-lg-12 col-xl-5">
                                    Fee: {selectedTimeSlot.preDiscountCost ? <span style={{ color: "grey", textDecoration: "line-through" }}>${selectedTimeSlot.preDiscountCost.toFixed(2)}</span> : ""} ${selectedTimeSlot.cost.toFixed(2)}
                                </div>
                                <div className="col-lg-12 col-xl-3">
                                    Tax: ${tax.toFixed(2)}
                                </div>
                                <div className="col-lg-12 col-xl-4 font-weight-bold">
                                    Total: ${(tax + selectedTimeSlot.cost).toFixed(2)}
                                </div>
                            </div>

                        </div>}
                        
                        <button className="btn btn-block btn-success" onClick={book} disabled={loading}>
                            Book It!
                        </button>
                        {selectedTimeSlot.cost > 0 && refundText && <p className="mt-2 text-center">{refundText}</p>}
                    </div>
                </div>
            </div>}
            {currentScreen === 3 && <div>
                <h1 className="text-center">You're Booked!</h1>

                <p className="text-center" style={{ fontSize: "large" }}>
                    <strong>Date/Time:</strong> {selectedTimeSlot.dateTime.format("LLL")}{selectedTimeSlot.timeZoneAbbreviation ? ` ${selectedTimeSlot.timeZoneAbbreviation}` : ""}
                </p>

                {selectedTimeSlot.eventLocation && <>
                    <h2 className="text-center">Your photoshoot is located at:</h2>

                    <address className="text-center">
                        <strong>
                            {selectedTimeSlot.eventLocation.name}
                        </strong><br />

                        {selectedTimeSlot.eventLocation.address1}<br />
                        {selectedTimeSlot.eventLocation.address2}{selectedTimeSlot.eventLocation.address2 && <br />}
                        {selectedTimeSlot.eventLocation.city}, {selectedTimeSlot.eventLocation.state} {selectedTimeSlot.eventLocation.zip}
                    </address>
                </>}

                {!selectedTimeSlot.eventLocation && <p className="text-center">To join this event, please log into MyJC.me at your scheduled time. You will be prompted to join this meeting.</p>}

                <p className='text-center mt-2'>
                    <button className="btn btn-lg btn-primary mr-2" onClick={downloadIcs}>
                        <i className="fa fa-calendar"></i>
                        Add to Calendar
                    </button>
                    {selectedTimeSlot.cost > 0 && <a href={`/BookPhotoshoot/Receipt?rsvpId=${rsvpId}&accountNumber=${accountNumber}`} className="btn btn-lg btn-success" target="_blank">
                        <i className="fa fa-usd"></i>
                        Print Receipt
                    </a>}
                </p>
            </div>}
            {currentScreen === 4 &&
            <div>
                <div className="row">
                    <div className="col-lg-12 col-xl-12">
                        <h2 className="text-center">
                            Please select a timezone on the <a href="talent/UserSettings">Profile</a> page to see accurate photoshoot dates & times.
                        </h2>
                    </div>
                </div>
            </div>}
            {bottomMessage && <p className="text-center mt-2">{bottomMessage}</p>}
        </>
    );
}